<script>
import CostSubmenu from "./components/CostSubmenu";
import VConnConfig from "@/components/Costs/VConnConfig";
import EcConnectionService from "@/services/EcConnectionService";

export default {
    props: {
        project_id: {}
    },
    components: { CostSubmenu, VConnConfig },
    data() {
        return {
            loading: true,
            connections: []
        };
    },
    async created() {
        await this.fetchData();
        this.loading = false;
    },
    methods: {
        async fetchData() {
            try {
                const { data } = await EcConnectionService.GET_listConnections(
                    this.project_id
                );
                this.connections = data.data;
            } catch (e) {
                console.log("fd e ", e);
            }
        }
    }
};
</script>

<template>
    <div class="container-fluid">
        <div class="row card-wrapper">
            <div class="col-12">
                <card body-classes="px-0">
                    <div
                        class="d-flex align-items-center mb-4 justify-content-between mx-4"
                    >
                        <h2 class="">
                            {{
                                $t("ec_connection.overview_over_ec_connections")
                            }}
                        </h2>
                        <cost-submenu
                            :project-id="project_id"
                            me="costs-inbox"
                        />
                    </div>

                    <v-loader :loading="loading" v-if="loading" />
                    <template v-else-if="connections.length > 0">
                        <v-table class="table table-mg">
                            <v-thead>
                                <v-tr>
                                    <v-th>{{
                                        $t("ec_connection.tbl_hdr_id")
                                    }}</v-th>
                                    <v-th>{{
                                        $t("ec_connection.tbl_hdr_created")
                                    }}</v-th>
                                    <v-th>{{
                                        $t("ec_connection.tbl_hdr_valid_from")
                                    }}</v-th>
                                    <v-th>{{
                                        $t("ec_connection.tbl_hdr_status")
                                    }}</v-th>
                                    <v-th>{{
                                        $t(
                                            "ec_connection.tbl_hdr_connection_type"
                                        )
                                    }}</v-th>
                                    <v-th>{{
                                        $t("ec_connection.tbl_hdr_last_sync")
                                    }}</v-th>
                                    <v-th>{{
                                        $t(
                                            "ec_connection.tbl_hdr_account_numbers"
                                        )
                                    }}</v-th>
                                </v-tr>
                            </v-thead>
                            <v-tbody>
                                <v-tr v-for="c in connections" :key="c.id">
                                    <v-td>{{ c.id }}</v-td>
                                    <v-td>{{
                                        $d(new Date(c.created), "short")
                                    }}</v-td>
                                    <v-td>{{
                                        $d(new Date(c.valid_from), "short")
                                    }}</v-td>
                                    <v-td>{{ c.status_name }}</v-td>
                                    <v-td
                                        >{{ c.connection_type_name }}
                                        <div class="small">
                                            {{ c.description }}
                                        </div>
                                    </v-td>
                                    <v-td>
                                        <template v-if="c.last_sync_time"
                                            >{{
                                                $d(
                                                    new Date(c.last_sync_time),
                                                    "long"
                                                )
                                            }}
                                        </template>
                                        <template v-else>---</template>
                                    </v-td>
                                    <v-td><v-conn-config :context="c"/></v-td>
                                </v-tr>
                            </v-tbody>
                        </v-table>
                    </template>
                    <div class="alert alert-warning" v-else>
                        {{
                            $t(
                                "ec_connection.no_ec_connections_for_this_project"
                            )
                        }}
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>
